import { Link } from 'react-router-dom';
import { useAuth } from '~/contexts/AuthContext';
import { signOut } from '~/lib/auth-client';
import { Button } from './ui/button';
import { useState } from 'react';
import { SnapticsWordmark } from '@snaptics/recorder-ui';
import { toast } from 'sonner';

export default function Header() {
  const { user, refetch } = useAuth();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleSignOut = async () => {
    try {
      setIsLoggingOut(true);

      // Call signOut API
      await signOut();

      // Refetch session to update auth state
      await refetch();

      // Clear all cookies
      document.cookie.split(';').forEach((c) => {
        document.cookie = c
          .replace(/^ +/, '')
          .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
      });

      // Clear session and local storage
      sessionStorage.clear();
      localStorage.clear();

      // Force a full page reload to clear all client state
      window.location.href = '/login';
    } catch (error) {
      console.error('Logout failed:', error);
      toast.error('Failed to logout. Please try again.');
      setIsLoggingOut(false);
    }
  };

  return (
    <header className="border-b bg-white">
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <Link to="/projects" className="flex items-center gap-2">
            <SnapticsWordmark size="md" theme="light" />
          </Link>
          <div className="flex items-center gap-4">
            {user && (
              <span className="text-sm text-gray-600">
                {user.name || user.email}
              </span>
            )}
            <Button
              variant="outline"
              size="sm"
              onClick={handleSignOut}
              disabled={isLoggingOut}
            >
              {isLoggingOut ? 'Logging out...' : 'Logout'}
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
}
